import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, of, Subject } from 'rxjs';
import { finalize, map, shareReplay, takeUntil } from 'rxjs/operators';
import { Modal } from '../../models/modal.model';
import { AppService } from '../../services/app.service';
import { ContentDocument } from '../../models/content-document.model';
import { HippoContentService } from '../../services/hippo-content.service';
import { LoaderService } from '../../services/loader.service';
import { ContentState } from '../../store/state/content.state';
import { ErrorHandlerUtil } from '../../utils/error-handler.util';

@Component({
    selector: 'u4-cpp-modal',
    templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit, OnDestroy {

    content: Observable<Modal>;
    isOpen: boolean;
    labels: {[key: string]: string};
    private destroy$: Subject<void> = new Subject<void>();
    
    constructor(
        private appService: AppService,
        private loaderService: LoaderService,
        private hippoContentService: HippoContentService,
        private errorHandlerUtil: ErrorHandlerUtil,
        private domSanitizer: DomSanitizer,
        private store: Store<ContentState>) {}
        
    @HostListener('document:click', ['$event'])
    documentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (target.classList && target.classList.contains('cpp-button--consent')) {
            this.close();
        }
    }

    ngOnInit() {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);
        this.appService.modal.pipe(
            takeUntil(this.destroy$)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        ).subscribe(this.onModalChange.bind(this));
    }

    onModalChange(value) {
        if (value instanceof Modal) {
            this.isOpen = true;
            this.content = of<Modal>(value);
        } else if (typeof value === 'string') {
            this.loaderService.addLoader(this);
            this.content = this.getModalContent(value).pipe(finalize(() => {
                this.loaderService.removeLoader(this);
            }));
            this.content.pipe(
                takeUntil(this.destroy$)
            ).subscribe(
                (success) => this.isOpen = !!success,
                (error: Error) => this.errorHandlerUtil.handleError(error));
        }
    }

    getModalContent(contentPath: string): Observable<Modal> {
        return this.hippoContentService.getContentDocument(contentPath).pipe(
            map((contentDocument: ContentDocument) => new Modal({
                title: contentDocument.title,
                body: this.domSanitizer.bypassSecurityTrustHtml(contentDocument.content)
            })),
            shareReplay(1)
        );
    }

    close(): void {
        this.isOpen = false;
    }


    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
